import React from 'react';
import classNames from 'classnames';

import { useOrderContext } from '@/components/modals/SubmitOrder/helpers';
import { useAuth } from '@/hooks/useAuth/useAuth';
import { UserRole } from '@/types';
import { formatPriceWithCurrency } from '@/utils/format-price';

import { ProposalBlockWrapper } from '../../../Common/ProposalBlockWrapper';
import { calculateTotalNetPayment } from '../../helpers';

import { Props } from './types';

import styles from './ContractSummary.module.scss';

export const ContractSummary = ({ total }: Props): JSX.Element | null => {
  const { userInfo } = useAuth();
  const state = useOrderContext();

  if (!state.isAccessProgram || userInfo?.role === UserRole['Sales']) {
    return null;
  }

  return (
    <>
      <ProposalBlockWrapper title="Contract summary">
        <section className={styles.details}>
          <section className={classNames(styles.row, styles.header)}>
            Total Net Payment to Company
          </section>
          <section className={styles.row}>
            <section>Total Price to Homeowner</section>
            <section className={styles.amount}>
              {formatPriceWithCurrency(Number(state?.order.totalContractAmount))}
            </section>
          </section>
          <section className={styles.row}>
            <section>Total Costs</section>
            <section className={classNames(styles.red, styles.amount)}>
              -{formatPriceWithCurrency(total)}
            </section>
          </section>
        </section>
        <section className={styles.total}>
          <section>Total Net Payment:</section>
          <section>
            {formatPriceWithCurrency(
              calculateTotalNetPayment(state?.order.totalContractAmount, total),
            )}
          </section>
        </section>
      </ProposalBlockWrapper>
      <br />
    </>
  );
};
